module.exports = __webpack_public_path__ + "img/studyimg2.1cdca848.jpg";